import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="357.072" height="218.469" viewBox="0 0 357.072 218.469">
    <g id="Group_1" data-name="Group 1" transform="translate(0 0)">
      <path id="Path_7" data-name="Path 7" d="M242.767,7.7h0L149.989,0,8.542,62.505,0,141.022l163.84,10.414Z" transform="translate(88.696 12.705) rotate(-3)" fill="#ffb500"/>
      <path id="Path_8" data-name="Path 8" d="M98.968,0,0,45.022,93.653,48.9Z" transform="translate(0 109.609) rotate(-3)" fill="#ffdf00"/>
      <g id="Component_1_1" data-name="Component 1 – 1" transform="translate(144.073 147.984)">
        <path id="Path_9" data-name="Path 9" d="M0,0,1.171,59.105,115.93,7.385Z" transform="translate(0 6.067) rotate(-3)" fill="#ffca00"/>
      </g>
      <path id="Path_10" data-name="Path 10" d="M0,23.366l83.262,5.46L51.81,0Z" transform="translate(147.11 189.682) rotate(-3)" fill="#ffdf00"/>
      <path id="Path_11" data-name="Path 11" d="M0,43.59,45.825,70.2,23.917,0Z" transform="translate(307.635 8.932) rotate(-3)" fill="#ffdf00"/>
      <path id="Path_12" data-name="Path 12" d="M0,31.869,117.025,94.9,164.9,7.69,72.156,0Z" transform="translate(166.449 8.64) rotate(-3)" fill="#ff8a00"/>
    </g>
  </svg>
);